import { useEffect } from 'react';
import { useHawkSearch } from 'shared/components/hawksearch/components/StoreProvider';

declare global {
	interface Window {
		/**
		 * The Tracking Id that was returned in the search response, undefined if no search has been performed
		 */
		HawkSearchTrackingId?: string;
	}
}

/**
 * SearchResultListener component listens for the changes
 * in store for search results and whenever there is a change it sets
 * a session key of "canGoBack" to true and populates TrackingId of the last search
 * as a global "HawkSearchTrackingId" variable
 */
function SearchResultListener() {
	const { store } = useHawkSearch();

	useEffect(() => {
		sessionStorage.setItem('canGoBack', 'true');
		// updating HawkSearchTrackingId that is used by hawksearch tracker to report product clicks from search page
		window.HawkSearchTrackingId = store.searchResults?.TrackingId;
	}, [store.searchResults]);

	return null;
}

export default SearchResultListener;
